import React, { useState, useContext } from "react";
import axios from "axios";
import {
  VStack,
  Button,
  Heading,
  Container,
  Box,
  FormControl,
  FormLabel,
  FormHelperText,
  useToast,
  Input,
} from "@chakra-ui/react";
import { UserContext } from "../context/UserContext";
import { useHistory } from "react-router-dom";

const Account = () => {
  const { user } = useContext(UserContext);
  const [input, setInput] = useState();
  const history = useHistory();
  const toast = useToast();

  const handleChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    setInput({ ...input, [name]: value });
  };

  const changePassword = (event) => {
    event.preventDefault();
    axios
      .post(`https://backendexample.sanbersy.com/api/change-password`, {
        current_password: input.password,
        new_password: input.newPassword,
        new_confirm_password: input.confirmPassword,
        token: user.token,
      })
      .then(() => {
        history.push("/");
        toast({
          title: "Password changed",
          position: "top",
          status: "success",
          duration: 1500,
        });
      });
  };

  return (
    <Box p={12} bg="white">
      <Container maxW="container.lg" p={4}>
        <Heading as="h1" size="xl" mb="4">
          Change Password
        </Heading>
        <Heading as="h2" size="sm" mb="4">
          Provide the following details to change your password
        </Heading>
        <form onSubmit={changePassword}>
          <VStack spacing="1.75rem">
            <FormControl id="password" isRequired>
              <FormLabel>Type your current password</FormLabel>
              <Input
                type="password"
                aria-label="password"
                autoComplete="off"
                name="password"
                onChange={handleChange}
              />
            </FormControl>
            <FormControl id="new-password" isRequired>
              <FormLabel>Type your new password</FormLabel>
              <Input
                type="password"
                aria-label="new password"
                autoComplete="off"
                name="newPassword"
                onChange={handleChange}
              />
              <FormHelperText>
                New password should be 8 characters long
              </FormHelperText>
            </FormControl>
            <FormControl id="confirm-password" isRequired>
              <FormLabel>Confirm your new password</FormLabel>
              <Input
                type="password"
                aria-label="confirm new password"
                autoComplete="off"
                name="confirmPassword"
                onChange={handleChange}
              />
            </FormControl>
            <Button type="submit" colorScheme="teal" variant="solid">
              Submit
            </Button>
          </VStack>
        </form>
      </Container>
    </Box>
  );
};

export default Account;
